/**
 * The signed-in CRM user's app_user id, read from the access token's
 * hook-built claim. Only that claim identifies the user; session.user
 * .app_metadata is raw_app_meta_data and can name someone else (REG-541).
 */
export function appUserIdFromSession(session: any): number | null {
  if (session?.access_token) {
    try {
      const payload = JSON.parse(atob(session.access_token.split('.')[1]));
      const fromPayload = Number(payload.app_metadata?.['core_crm.app_user']?.id);
      if (Number.isFinite(fromPayload) && fromPayload > 0) return fromPayload;
    } catch (error) {
      console.error('Failed to decode the session token for the app user:', error);
    }
  }

  return null;
}
